// extracted by mini-css-extract-plugin
export default {"wrapper":"workflow_wrapper__ze9MS"};